// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"49c4d83f","453":"2153e1d5"}[chunkId] + ".chunk.js";
};